import styled from '@emotion/styled';
import { TabletWidth } from '../../../../global.style';

export const TwoSidedLayout = styled.div`
  display: flex;
`;

export const Col = styled.div`
  width: 50%;

  @media (max-width: ${TabletWidth}px) {
    width: 100%;
  }
`;

export const ContentCol = styled(Col)<{ location: 'left' | 'right' }>`
  display: flex;
  justify-content: ${(props) => (props.location === 'left' ? 'flex-end' : 'flex-start')};

  @media (max-width: ${TabletWidth}px) {
    justify-content: center;
  }
`;
